'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _iconfont = require('@/components/iconfont');

var _iconfont2 = _interopRequireDefault(_iconfont);

var _isLogin = require('@/mixins/isLogin');

var _isLogin2 = _interopRequireDefault(_isLogin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      navList: [],
      currentName: false,
      currentView: '',
      isShowAdmin: false,
      searchCourseNames: [],
      value: '',
      visible: false
    };
  },

  mixins: [_isLogin2.default],
  created: function created() {
    var arrStr = localStorage.getItem('searchCourseNames') || '';
    this.searchCourseNames = arrStr ? JSON.parse(arrStr) : [];
  },

  watch: {
    '$route.path': function $routePath(val) {
      if (val != '/course/course-list') {
        this.value = '';
      }
    }
  },
  mounted: function mounted() {
    var that = this;
    var element = document.getElementsByClassName('searchinput')[0];
    element && element.addEventListener('click', function (event) {
      // 当鼠标进入元素时执行的代码
      if (that.value) {
        that.visible = false;
      } else {
        that.visible = true;
      }
    });
    element && element.addEventListener('blur', function (event) {
      // 当鼠标进入元素时执行的代码
      that.visible = false;
    });
  },

  methods: {
    blur: function blur() {
      this.visible = false;
    },
    click: function click() {
      // if (!this.isLogin('login')) return
      if (!this.value) return;
      if (!this.searchCourseNames.includes(this.value)) {
        this.searchCourseNames.unshift(this.value);
        if (this.searchCourseNames.length > 5) {
          this.searchCourseNames = this.searchCourseNames.slice(0, 5);
        }
        localStorage.setItem('searchCourseNames', (0, _stringify2.default)(this.searchCourseNames));
      }
      this.$router.push({
        name: 'course-list',
        query: {
          searchCourseName: this.value
        }
      });
    },
    change: function change() {
      if (this.value) {
        this.visible = false;
      } else {
        this.visible = true;
      }
    },
    goDetail: function goDetail(val) {
      // if (!this.isLogin('login')) return
      this.value = val;
      this.$router.push({
        name: 'course-list',
        query: {
          searchCourseName: val
        }
      });
    },
    deleteAll: function deleteAll() {
      this.searchCourseNames = [];
      localStorage.removeItem('searchCourseNames');
    },
    deleteOne: function deleteOne(index) {
      this.searchCourseNames.splice(index, 1);
      localStorage.setItem('searchCourseNames', (0, _stringify2.default)(this.searchCourseNames));
    }
  },
  components: {
    Iconfont: _iconfont2.default
  }
};